import { SupplierDriverDocumentType } from 'src/types/enums';

export const SUPPLIER_DRIVER_DOCUMENT_TYPES = [
  {
    type: SupplierDriverDocumentType.ProofOfLegalResidenceAndWorkPermit,
    label: 'Verblijf & werkvergunning',
    shortLabel: 'Verblijf',
    description: 'Bewijs van wettig verblijf en werkvergunning',
  },
  {
    type: SupplierDriverDocumentType.DriverAttestation,
    label: 'Chauffeursattestatie',
    shortLabel: 'Attestatie',
    description: 'Chauffeursattestatie',
  },
  {
    type: SupplierDriverDocumentType.A1Document,
    label: 'A1-document',
    shortLabel: 'A1',
    description: 'Bevestiging van toepasselijke socialezekerheidswetgeving',
  },
  {
    type: SupplierDriverDocumentType.IMIDeclaration,
    label: 'IMI-verklaring',
    shortLabel: 'IMI',
    description: 'Detachering van werknemers (IMI)',
  },
] as const;
